import { useSidebar } from '@bpinternal/ui-kit-next'
import { useRef } from 'react'
import { cn } from '~/utils/cn'

type Props = {
  name: string
  actionButton?: JSX.Element
  children: React.ReactNode
  forceNameDisplay?: boolean
  sticky?: boolean
}

export function Section(props: Props) {
  const { open: sidebarOpen } = useSidebar()
  const sectionRef = useRef<HTMLDivElement>(null)

  return (
    <div ref={sectionRef} className={cn(sidebarOpen && 'w-full px-2')}>
      <div
        className={cn(
          'sticky top-16 z-10 -mx-2 flex flex-col items-center justify-between bg-background px-2 lg:py-4 lg:pb-10'
        )}
      >
        <div className="flex w-full justify-between">
          <h3 className={props.forceNameDisplay ? 'text-2xl font-semibold' : 'hidden text-2xl font-semibold lg:block'}>
            {props.name}
          </h3>
          {props.actionButton}
        </div>
      </div>
      {props.children}
    </div>
  )
}
